export function isVisible(el) {
  return window.getComputedStyle(el).display !== 'none';
}


//////////////////
// WEBPACK FOOTER
// /data/wp-content/themes/gottwines/node_modules/tiny-slider/src/helpers/isVisible.js
// module id = 43
// module chunks = 0